import { useEffect, useState } from "react";
import {
  FaSearch,
  FaRegFileAlt,
  FaThumbsUp,
  FaTicketAlt,
  FaRegCheckCircle,
  FaTimesCircle,
  FaDiceOne,
} from "react-icons/fa";
import { LiaCheckCircle } from "react-icons/lia";
import { PiNumberCircleOneLight, PiNumberCircleTwoLight, PiNumberCircleThreeLight } from "react-icons/pi";
import { IoFilter } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import { getAccessToken } from "../../storage/storage";
import axios from "axios";
import { FormatDate } from "../../utils/FormateDate";
import { TableSkelton } from "../../components/Skeletons";
import { MdOutlineRemoveRedEye } from "react-icons/md";

export default function UpcomingStays() {
  const token = getAccessToken();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const Navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");
  const [cleaners, setCleaners] = useState([]);
  const [unassignedGuestStays, setUnassignedGuestStays] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isCancelledStays, setIsCancelledStays] = useState(false);

  const filteredCleaners = cleaners.filter((stay) => {
    const query = search.toLowerCase();

    return (
      stay.property_name?.toLowerCase().includes(query) ||
      stay.cleaner_name?.toLowerCase().includes(query) ||
      String(stay.id)?.toLowerCase().includes(query)
    );
  });

  const getPropertyColor = (color) => {
    const colorMap = {
      "Pink": "#FF69B4",
      "Teal": "#008080",
      "Blue": "#0000FF",
      "Green": "#008000",
      "Purple": "#800080",
      "Orange": "#FFA500",
      "Red": "#FF0000",
      "Yellow": "#FFD700",
    };
    return colorMap[color] || "#6B7280"; // Default gray color
  };

  const HandleStays = () => {
    sessionStorage.removeItem("cleanerEdit");
    Navigate("/stays/add-stays");
  };

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${BASE_URL}/api/stays/?cancelled=${isCancelledStays}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setCleaners(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching options:", error);
        setLoading(false);
      });
  }, [isCancelledStays]);

  useEffect(() => {
    axios
      .get(`${BASE_URL}/api/unassigned-guest-stays/`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("unassigned-guest-stays " + response.data);
        setUnassignedGuestStays(response.data);
      })
      .catch((error) => {
        console.error("Error fetching options:", error);
      });
  }, []);

  const handleTaskSheetClick = (id) => {
    Navigate(`/task-sheet/${id}`);
  };

  const handleInvoiceClick = (guestStayId) => {
    Navigate(`/invoice/${guestStayId}`);
  };

  const handleAddCleaner = (stay) => {
    sessionStorage.setItem("cleanerEdit", JSON.stringify(true)); // Store in session
    Navigate("/stays/add-stays", { state: { stay } }); // Send stay data via location
  };

  const getLodgifyStatusBadgeColor = (status) => {
    switch (status?.toLowerCase()) {
      case "booked":
        return "bg-green-100 text-green-800";
      case "open":
        return "bg-yellow-100 text-yellow-800";
      case "declined":
        return "bg-red-100 text-red-800";
      case "tentative":
        return "bg-gray-100 text-gray-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  return (
    <div className="flex lg:flex-row flex-col lg:items-start items-center px-6 w-full h-full pb-8 overflow-x-hidden">
      {/* Setup Tasks Component Removed */}

      <div className="lg:px-7px-4 mt-8 mb-16 h-[100vh] w-full">
        {/* <h1 className="md:text-3xl text-lg font-bold text-[#586989] mb-8">
          Property Owners Dashboard
        </h1> */}

        <div className="flex justify-between w-[85%] items-center ">
          <h1 className="md:text-3xl text-lg font-bold text-[#586989] mb-8 ">Upcoming Stays</h1>
          <button
            onClick={HandleStays}
            className="bg-[#586989] text-white px-6 py-3 rounded-md md:flex items-center justify-center hidden"
          >
            + Add New Stay
          </button>
        </div>
        <p className="text-gray-600 pt-2">
          Manage guest stays and cleaning assignments
        </p>

        <div className="flex md:flex-row flex-col gap-2 mt-4 items-center">
          <div className="relative md:w-[40%] w-full">
            <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500" />
            <input
              className="w-full p-2 border outline-none h-[55px] px-4 rounded-lg pl-10"
              placeholder="Search by property, reference, or cleaner"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <button
            className={`px-6 py-3 rounded-md flex items-center justify-center h-[55px] border border-[#586989] transition-colors
    ${isCancelledStays
                ? "bg-[#586989] text-white"
                : "bg-transparent text-black"
              }`}
            onClick={() => setIsCancelledStays(!isCancelledStays)}
          >
            Cancelled Bookings
          </button>
        </div>

        {!isCancelledStays && unassignedGuestStays?.unassigned_stays?.length > 0 &&
          unassignedGuestStays.unassigned_stays.map((stay) => (
            <div
              key={stay.id}
              className="flex md:flex-row flex-col gap-4 mt-4 bg-orange-100 border-l-4 border-orange-500 text-orange-700 p-4"
              role="alert"
            >
              <p className="font-bold">{stay.property_name}</p>
              <p>Stay reference {stay.id} requires to assign cleaner</p>
            </div>
          ))}

        <div className="relative mt-4 pb-5">
          <div
            className="border border-[#DFDFDF] bg-white rounded-lg shadow-md overflow-auto h-[70vh]"
          >
            <table className="w-full border-collapse">
              <thead className="sticky top-0 bg-[#FFF5CE] text-[#586989] z-10">
                <tr>
                  <th className="p-4 text-center min-w-[150px]">
                    Stay ID
                  </th>
                  <th className="p-2 text-center min-w-[150px]">Property Name</th>
                  <th className="p-2 text-center min-w-[150px]">Booking Status</th>
                  <th className="p-2 text-center min-w-[150px]">Check-in</th>
                  <th className="p-2 text-center min-w-[150px]">Check-out</th>
                  <th className="p-2 text-center min-w-[150px]">#Guests</th>
                  <th className="p-2 text-center min-w-[150px]">#Pets</th>
                  <th className="p-2 text-center min-w-[150px]">Cleaner</th>
                  <th className="p-2 text-center min-w-[150px]">Cleaner Status</th>
                  <th className="p-2 text-center min-w-[150px]">
                    Invoice Status
                  </th>
                  <th className="py-3 px-4 min-w-[150px] text-center">
                    Action Date
                  </th>
                  <th className="p-2 text-center min-w-[150px]">Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <TableSkelton />
                ) : cleaners.length > 0 ? (
                  filteredCleaners.map((stay, index) => (
                    <tr key={index} className="border-b">
                      <td className="p-4 text-center whitespace-nowrap">
                        <div className="px-3 py-1 rounded" style={{ backgroundColor: getPropertyColor(stay?.property_details?.property_color), opacity: 0.6 }}>
                          <span className="text-sm font-medium" style={{ color: 'white' }}>#{stay.id}</span>
                        </div>
                      </td>
                      <td className="p-2 text-center whitespace-nowrap">
                        {stay.property_name}
                      </td>
                      <td className="p-2 text-center whitespace-nowrap">
                        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full font-medium text-xs ${getLodgifyStatusBadgeColor(stay.lodgify_status)}`}>
                          {stay.lodgify_status}
                        </span>
                      </td>
                      <td className="p-2 text-center whitespace-nowrap">
                        {FormatDate(stay.check_in_date)}
                      </td>
                      <td className="p-2 text-center whitespace-nowrap">
                        {FormatDate(stay.check_out_date)}
                      </td>
                      <td className="p-2 text-center whitespace-nowrap">
                        {stay.number_of_guests}
                      </td>
                      <td className="p-2 text-center whitespace-nowrap">
                        {stay.number_of_pets}
                      </td>
                      {stay.status !== "CANCELLED" ? <td className="p-2 text-center ">
                        {stay?.cleaner_name ? (
                          stay?.cleaner_name
                        ) : (
                          <button
                            onClick={() => handleAddCleaner(stay)}
                            className="bg-blue-500 text-white px-2 py-1 rounded"
                          >
                            Add Cleaner
                          </button>
                        )}
                      </td> : <td className="p-2 text-center ">-</td>}

                      <td className="p-2 text-center whitespace-nowrap">
                        {stay.status !== "CANCELLED" ? stay.status || "-" : <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-white bg-[#EF4444]`}>
                          {stay.status}
                        </span>}
                      </td>
                      <td className="p-2 text-center whitespace-nowrap">
                        {stay?.invoices[0]?.status
                          ? stay.invoices[0].status.toUpperCase()
                          : "-"}
                      </td>

                      <td className="px-4 py-6 text-center flex items-center justify-center">
                        {stay?.invoices[0]?.status === "approved" ||
                          stay?.invoices[0]?.status === "paid" ||
                          stay?.invoices[0]?.status === "rejected"
                          ? stay?.invoices[0]?.action_date
                            ? FormatDate(stay?.invoices[0].action_date)
                            : "-"
                          : "-"}
                      </td>
                      {stay.status !== "CANCELLED" ? <td className="p-2 text-green-700 text-center whitespace-nowrap">
                        {stay.status === "ACCEPTED" ? (
                          <>
                            <span
                              onClick={() => handleTaskSheetClick(stay.id)}
                              className="cursor-pointer flex items-center gap-1"
                            >
                              <FaRegFileAlt /> View Task Sheet
                            </span>
                            <span
                              onClick={() => handleInvoiceClick(stay.id)}
                              className="cursor-pointer flex items-center gap-1"
                            >
                              <FaRegFileAlt /> View Invoice
                            </span>
                            <div
                              className="flex items-center justify-center cursor-pointer"
                              onClick={() => handleAddCleaner(stay)}
                            >
                              <MdOutlineRemoveRedEye />
                            </div>
                          </>
                        ) :
                          <div
                            className="flex items-center justify-center cursor-pointer"
                            onClick={() => handleAddCleaner(stay)}
                          >
                            <MdOutlineRemoveRedEye />
                          </div>
                        }
                      </td> : <td className="p-2 text-center ">-</td>}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="10"
                      className="text-center text-lg font-bold text-[#586989] h-[400px]"
                    >
                      No Upcoming stays
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}